<script>
    import { metaInfo } from "@/core/MetaInfo";

    export default {
        name: "Versions",
        props: {
            vendorId: String,
        },
        data() {
            return {
                list: [],
                isLoading: true,
            };
        },
        mounted() {
            this.getList();
        },
        methods: {
            selected(item) {
                this.$router.push({
                    name: "VersionEdit",
                    params: {
                        slug: item.id,
                        modelId: this.$route.params.slug,
                        vendorId: this.vendorId,
                    },
                });
            },
            getList() {
                this.$store.autoAdminApi
                    .getVersions(this.$route.params.slug)
                    .then(({ data }) => {
                        this.list = data.items;
                        this.isLoading = false;
                    });
            },
            goTo() {
                this.$router.push({
                    name: "VersionNew",
                    params: {
                        modelId: this.$route.params.slug,
                        vendorId: this.vendorId,
                    },
                });
            },
        },
        metaInfo() {
            return metaInfo.getMeta("home");
        },
    };
</script>

<template>
    <section class="section">
        <div class="field">
            <b-button @click="goTo" type="is-primary" outlined>
                Добавить комплектацию
            </b-button>
        </div>

        <h1 class="title">Список комплектаций</h1>

        <b-table :data="list" @select="selected" hoverable>
            <b-loading
                v-model="isLoading"
                :can-cancel="true"
                :is-full-page="false"
            ></b-loading>

            <b-table-column field="name" label="Название" sortable v-slot="props">
                {{ props.row.name }}
            </b-table-column>

            <b-table-column field="id" label="Id" sortable v-slot="props">
                {{ props.row.id }}
            </b-table-column>
        </b-table>
    </section>
</template>

<style lang="scss"></style>
